// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"fee056e2","378":"4ae18f89","556":"4ae18f89","728":"4ae18f89"}[chunkId] + ".chunk.css";
};